import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Container from "../ui/Container";

const Hero = () => {
  return (
    <div className="relative pt-20 overflow-hidden">
      {/* Background shapes */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/3 left-1/4 w-[600px] h-[600px] bg-accent/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 right-0 w-[60%] h-[50%] bg-gradient-to-r from-primary/10 to-accent/10 rounded-full blur-3xl"></div>
      </div>

      <Container className="pt-20 pb-24 md:pt-28 md:pb-32">
        <div className="flex flex-col md:flex-row md:items-center md:space-x-8 lg:space-x-16">
          <div className="flex-1 mb-10 md:mb-0">
            <div className="tag mb-6 opacity-0 animate-fade-in" style={{ animationDelay: "0.2s" }}>
              Передовые технологические решения
            </div>
            <h1 className="heading text-4xl md:text-5xl xl:text-6xl font-bold leading-tight md:leading-tight xl:leading-tight mb-6 opacity-0 animate-fade-in" style={{ animationDelay: "0.4s" }}>
              Инновационная разработка <span className="text-gradient">программного обеспечения</span> для бизнеса
            </h1>
            <p className="text-muted-foreground text-lg mb-8 max-w-2xl opacity-0 animate-fade-in" style={{ animationDelay: "0.6s" }}>
              Мы специализируемся на создании высокоэффективных решений для ритейла, электронной коммерции и логистики, которые помогают бизнесу достигать новых высот.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 opacity-0 animate-fade-in" style={{ animationDelay: "0.8s" }}>
              <Link to="/products" className="button-primary">
                Исследовать решения
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
              <Link to="/contact" className="button-secondary">
                Связаться с нами
              </Link>
            </div>
          </div>
          {/* <div className="relative mb-8 md:mb-0">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-lg">
              <video
                className="w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src={video} type="video/mp4"/>
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="flex items-center space-x-2 text-white/90">
                  <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium">Live Demo</span>
                </div>
              </div>
            </div>
            <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-accent/10 rounded-xl blur-xl animate-float"></div>
            <div className="absolute -left-4 -top-4 w-20 h-20 bg-primary/10 rounded-lg blur-xl animate-float"></div>
          </div> */}
          {/* <Link to="/news" className="flex-1 opacity-0 animate-fade-in" style={{ animationDelay: "1s" }}>
            <div className="relative">
              <div className="h-auto bg-gradient-to-tr from-primary/20 to-accent/20 rounded-2xl overflow-hidden glass p-4 shadow-lg">
                <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?q=80&w=2670')] bg-cover bg-center opacity-10 rounded-2xl"></div>
                <div className="relative h-full flex flex-col justify-between">
                  <div className="grid grid-cols-3 gap-2">
                    <div className="h-2 bg-white/30 rounded-full"></div>
                    <div className="h-2 bg-white/20 rounded-full"></div>
                    <div className="h-2 bg-white/10 rounded-full"></div>
                  </div>
                  <div className="flex flex-col items-center justify-center space-y-4 py-8">
                  <div className="text-center space-y-1">
                      <p className="text-sm font-medium text-white">Скоро...</p>
                  </div>
                    <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-primary">
                      <path d="M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 17V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="8" cy="17" r="1" fill="currentColor"/>
                      <circle cx="16" cy="17" r="1" fill="currentColor"/>
                      <circle cx="12" cy="7" r="1" fill="currentColor"/>
                    </svg>
                    </div>
                    <div className="text-center space-y-1">
                      <p className="text-sm font-medium text-white/70">Передовая технология</p>
                      <h3 className="text-xl font-medium text-white">StackAdvance UX Vision</h3>
                    </div>
                  </div>
                  <div className="grid grid-cols-5 gap-1">
                    <div className="h-1 bg-primary/40 rounded-full"></div>
                    <div className="h-1 bg-primary/30 rounded-full"></div>
                    <div className="h-1 bg-primary/20 rounded-full"></div>
                    <div className="h-1 bg-primary/10 rounded-full"></div>
                    <div className="h-1 bg-primary/5 rounded-full"></div>
                  </div>
                </div>
              </div>
              <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-accent/10 rounded-xl blur-xl animate-float"></div>
              <div className="absolute -left-4 -top-4 w-20 h-20 bg-primary/10 rounded-lg blur-xl animate-float"></div>
            </div>
          </Link> */}
        </div>
      </Container>
    </div>
  );
};

export default Hero;
